const gigyaWebSDK = window.gigya;

export default gigyaWebSDK;